import { Component, OnInit } from '@angular/core';
import { UserService, HelpKey } from '../../services/user.service';
import { User } from '../../models/user';
import { MatDialog } from '@angular/material/dialog';
import { HelpDialogComponent } from '../../pages/help-dialog/help-dialog.component';
import { AcknowledgeDialogComponent } from '../../pages/acknowledge-dialog/acknowledge-dialog.component';

@Component({
  selector: 'app-ntrip-credential',
  templateUrl: './ntrip-credential.component.html',
  styleUrls: ['./ntrip-credential.component.scss']
})
export class NtripCredentialComponent implements OnInit {
  selectedUser: User | null = null;

  constructor(private userService: UserService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.loadUser();
  }

  loadUser(): void {
    this.userService.getUser().subscribe((data: User[]) => {    
      this.selectedUser = data[0];
    });
  }

  onSubmit(): void {
    if (this.selectedUser) {
      this.userService.updateCurrentUser(this.selectedUser).subscribe({
        next: (response) => {
          this.loadUser(); 
    this.dialog.open(AcknowledgeDialogComponent, { data: 'Credential update successful.' });
          this.userService.ntripApplyWithLogging();
        },
        error: (error) => {
          this.loadUser();  
          this.dialog.open(AcknowledgeDialogComponent, { data: 'Credential update failed!' });
        }
      });
    }
  }

  showHelp(key: HelpKey): void {
    this.dialog.open(HelpDialogComponent, { width: '250px', data: this.userService.helpData[key] });
  }

  openInfo(message: string): void {
    this.dialog.open(AcknowledgeDialogComponent, { data: message });
  }
}


